"use client";

import { useBeforeGtmEvent } from "@/app/_helpers/Events";
import type { KlaviyoItem } from "@/app/_helpers/klaviyoEvents";
import { useSelection } from "@frend-digital/centra/client";
import { gtag, type BeforeEvent, type GTMProduct } from "@frend-digital/events/gtm";
import { useEffect } from "react";

export const ViewItemList = ({
	id,
	name,
	items,
}: { id: string; name: string; items: GTMProduct[] }) => {
	const { data: currency } = useSelection({
		select: (data) => data.selection?.currency,
	});
	useEffect(() => {
		if (!currency) return;

		gtag.viewItemList({
			item_list_name: name,
			item_list_id: id,
			currency: currency,
			items: items,
		});
	}, [currency, items, id, name]);
	return null;
};

export const ViewItem = ({
	price,
	item,
	klaviyo,
}: { price: number; item: GTMProduct; klaviyo?: KlaviyoItem }) => {
	const beforeEvent = useBeforeGtmEvent();

	const { data: currency } = useSelection({
		select: (data) => data.selection?.currency,
	});

	useEffect(() => {
		if (!currency || !beforeEvent) return;

		const finalBeforeEvent: BeforeEvent = async (e) => {
			const event = (await beforeEvent?.(e)) || e;

			return {
				...event,
				klaviyo,
			};
		};

		gtag.viewItem(
			{
				currency,
				value: price,
				items: [item],
			},
			finalBeforeEvent,
		);
	}, [item, price, currency, klaviyo, beforeEvent]);

	return null;
};
